import React from 'react'

import BackDrop from './../../../resources/HomePageResources/new-york.svg'
import PlatformLeft from './../../../resources/HomePageResources/platform-down-left.svg'
import PlatformRight from './../../../resources/HomePageResources/platform-down-right.svg'
import '../../../styles/HomePageStyles/PlatformStyles/newyork.css'
import NewYorkBank from './../../../resources/HomePageResources/new-york-bank.svg'
import NewYorkPeople from './../../../resources/HomePageResources/new-york-people.svg'
import NewYorkLamp from './../../../resources/HomePageResources/new-york-lamp.svg'
import NewYorkEth from './../../../resources/HomePageResources/new-york-logo.svg'
import NewYorkPipe from './../../../resources/HomePageResources/pipes/new-york-pipe.svg'

export default class TokyoPlatform extends React.Component{
    render(){
        return(
            <div className="plat__container" style={{width: '340px'}}>
                <div className="plat__backdrop">
                    <img className="plat__backdrop-img" src={BackDrop} />

                    <div className="plat__content-box new-york__content">

                        <div className="new-york__bank">
                            <img className="new-york__bank-img" src={NewYorkBank}/>
                        </div>
                        <div className="new-york__people">
                            <img className="new-york__people-img" src={NewYorkPeople}/>
                            {/* <div>
                                <img classname="new-york__lamp" src={NewYorkLamp}/>
                            </div> */}
                            <div className="new-york__eth">
                                <img style={{position: 'relative', width: '100%'}} src={NewYorkEth}/>
                            </div>
                        </div>

                    </div>

                </div>

                <div className="plat__platform">
                    <img className="plat__platform-left" src={PlatformLeft} />
                    <div className="plat__platform-middle" />
                    <img className="plat__platform-right" src={PlatformRight} />
                </div>

                <div className="new-york__pipe">
                    <img src={NewYorkPipe} />
                    <div className="new-york-pipe-c-1" />
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/HomePage/Platforms/NewYorkPlatform.js